<template>
  <HistoryTabTemplate
    :items="items"
    :loading="loading">
    <template v-for="(historyItem, itemIndex) in itemsSort">
      <component
        :is="historyItem.component"
        :key="`event-history-${itemIndex}-new`"
        class="mt-4"
        :data-qa="`event-history-${itemIndex}`"
        :item="historyItem"
        :spr="spr"/>
    </template>
  </HistoryTabTemplate>
</template>
<script>
import HistoryTabTemplate from 'components/tenders/tender page/HistoryTabTemplate.vue'
import LayoutHistoryItem from 'components/common/blocks/history/layout/LayoutHistoryItem.vue'

import godModeMixin from 'mixins/godModeMixin'

import { getAllEventComponentNames } from './components/eventTypes'

/**
 * История действий с тендером
 * @vue-prop {Array} items - Данные истории
 *
 * @vue-computed {Array} itemsSort - Отсортированные по дате данные событий
 */
export default {
  name: 'eventHistory',
  mixins: [ godModeMixin ],
  mounted() {
    this.registerCustomEventComponents()
  },
  methods: {
    /**
     * Регистрирует имена всех компонентов событий истории во Vue.
     * Присваивает null, чтобы Vue "знал" о компонентах заранее и не ругался на неизвестные компоненты в шаблоне.
     * Динамический импорт самих компонентов выполняется позже в itemsSort.
     */
    registerCustomEventComponents() {
      const allComponents = getAllEventComponentNames()
      allComponents.forEach(componentName => {
        this.$options.components[componentName] = null // null — чтобы избежать предупреждений Vue о неизвестных компонентах
      })
    }
  },
  computed: {
    itemsSort() {
      if (!this.items) { return [] }
      const result = [...this.items]
      const allComponentNames = getAllEventComponentNames()
      result.map(item => {

        const componentName = 'HistoryItem' + (item.eventType ? item.eventType.charAt(0).toUpperCase() + item.eventType.slice(1).toLowerCase() : '')
        if (allComponentNames.includes(componentName)) {
          item.component = () => import(`./components/eventTypes/${componentName}.vue`)
        } else {
          item.component = 'LayoutHistoryItem'
        }
        return item
      })
      return result.sort((a, b) => new Date(a.dateAdded) - new Date(b.dateAdded))
    }
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    mode: {
      type: String,
      validator: function (value) {
        return ['small', 'big'].indexOf(value) !== -1
      },
      default: 'small'
    },
    spr: {
      type: Object
    },
    loading: {
      type: Boolean
    },
  },
  components: {
    HistoryTabTemplate,
    LayoutHistoryItem,
  }
}
</script>
<style scoped>
.event-history-card {
  text-align: left;
  color: var(--black-color);
}
.event-history-data {
  font-size: 12px;
  line-height: 14px;
  padding: 0 0 5px 5px;
  color: rgba(var(--black-color-rgba), 0.5);
}
.event-history-data.big {
  margin-right: 8px;
  margin-top: 12px;
  width: 160px;
}
.column-2.big {
  width: calc(100% - 110px);
}
.event-history-item {
  display: flex;
  flex-wrap: wrap;
  width: calc(100% - 35px);
}
.event-history-row {
  padding-top: 7px;
}
.event-history-name {
  font-weight: 500;
  padding-left: 8px;
  margin: auto 0 auto 2px;
  padding-top: 5px;
  font-size: 14px;
  line-height: 18px;
}
.event-history-event {
  padding-left: 7px;
  margin: auto 0;
  text-decoration: underline;
  padding-top: 5px;
}
.event-history-reason {
  background: var(--color-main-green);
  border-radius: 0 25px 25px 25px;
  padding: 13px 15px 15px 15px;
  line-height: 18px;
  margin-top: 10px;
  width: 100%;
}
.event-history-reason-tag {
  font-weight: 500;
  font-size: 11px;
  color: var(--v-secondary__green_not_active-base);
  border: 1px solid var(--v-secondary__green_not_active-base);
  border-radius: 50px;
  padding: 2px 5px;
  height: 23px;
}
</style>
